import {
  useCallback,
} from 'react';
import type {
  ReactElement,
} from 'react';

import type {
  Components,
  FormatOptionLabel,
  GetOptionLabel,
  OnSelect,
} from './types';

export type DropdownItemProps<Option> = {
  components: Components;
  getOptionLabel: GetOptionLabel<Option>;
  formatOptionLabel: FormatOptionLabel<Option>;
  option: Option;
  isHighlighted: boolean;
  onSelect: OnSelect<Option>;
  setHighlightedIndex: (index: number) => void;
  index: number;
};

export function DropdownItem<Option>({
  components,
  getOptionLabel,
  formatOptionLabel,
  isHighlighted,
  option,
  onSelect,
  setHighlightedIndex,
  index,
}: DropdownItemProps<Option>): ReactElement {
  const onClick = useCallback(() => {
    onSelect(getOptionLabel(option), option);
  }, [onSelect, option, getOptionLabel]);

  const onMouseEnter = useCallback(() => {
    setHighlightedIndex(index);
  }, [setHighlightedIndex, index]);

  const {
    MenuItem,
  } = components;

  return (
    <MenuItem
      $isHighlighted={isHighlighted}
      onMouseEnter={onMouseEnter}
      onClick={onClick}
    >
      {formatOptionLabel(option)}
    </MenuItem>
  );
}
